import { createContext, useContext } from 'react'
import { BookingStore } from './types'

// Create context with the same interface as the Zustand store
export const BookingContext = createContext<BookingStore | null>(null)

// Hook to access booking context
export function useBookingContext() {
  const context = useContext(BookingContext)

  if (!context) {
    throw new Error('useBookingContext must be used within a BookingProvider')
  }

  return context
}
